import { createAction, props } from '@ngrx/store';
import { type } from '@app/util/util';

import { HeaderSelection } from '@header/entities/header-selection';
import { DsHeaderConfig } from '@header/entities/ds-header-config';

export const setHeaderStyleAction = createAction(
  type('[Header/Data] Set Header Style'),
  props<{ selection: HeaderSelection }>()
);

export const setDsHeaderConfigAction = createAction(
  type('[Header/Data] Set Ds Header Config'),
  props<{ config: DsHeaderConfig }>()
);

export const headerActions = {
  setHeaderStyleAction,
  setDsHeaderConfigAction
};
